// extracted by mini-css-extract-plugin
export var container = "HeaderRssFeedList-module--container--Kusyl";